angular.module('gym.privacy_policies').controller('EditPrivacyPolicyCtrl', ["$scope", "$state", "$filter", "loadingAnimation", "gym", "PrivacyPolicies", "policy", "title", "policiesMeta", function($scope, $state, $filter, loadingAnimation, gym, PrivacyPolicies, policy, title, policiesMeta) {
  var create, update;
  $scope.pageTitle = title;
  $scope.policy = policy;
  $scope.contexts = policiesMeta.contexts.filter(function(context) {
    return context[0] !== 'book_and_pay_contact_details' || gym.attributes.book_and_pay_enabled;
  });
  $scope.getContextDescription = function() {
    var context;
    if (!policy.context) {
      return;
    }
    context = _.find(policiesMeta.context_descriptions, function(item) {
      return item[0] === policy.context;
    });
    return context != null ? context[1] : void 0;
  };
  $scope.save = function() {
    loadingAnimation.show();
    if (policy.id) {
      return update();
    } else {
      return create();
    }
  };
  create = function() {
    return PrivacyPolicies.post($scope.policy).then(function(response) {
      return $state.go('gym.privacy_policies.list');
    }, function(error) {
      loadingAnimation.hide();
      return angular.extend($scope.policy, error.data);
    });
  };
  return update = function() {
    return $scope.policy.save().then(function(response) {
      return $state.go('gym.privacy_policies.list');
    }, function(error) {
      loadingAnimation.hide();
      return angular.extend($scope.policy, error.data);
    });
  };
}]);
